import React from 'react'
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { isMobile } from '../../service';
const DefaultMenus = ({ items, open,onClick }) => {
    if (isMobile()) {
        return (<div  className={`
            overflow-hidden
            transition-all duration-500 ease-in-out
            ${open ? "max-h-[1000px]" : "max-h-0"}
          `}
          >
                    <ul className='flex flex-col  m-0 gap-3  w-full my-2 '>
                        {items && items?.map((i_, i) => {
                            return <li key={i} className='flex items-center justify-start text-sm text-left hover:text-[--color-button-3] transition-all duration-150'>
                                <Link to={i_.href} onClick={onClick} >{i_.label}</Link>
                            </li>
                        })}
                    </ul>
    
                </div>)
    } else {
        return (
            <div className={`absolute left-0 right-0 top-[calc(100%+20px)] bg-white lg:shadow-md  z-50
        h-auto overflow-hidden  min-w-[180px]
        opacity-0 translate-y-[-10px] 
       ${open ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-2 pointer-events-none"}
      transition-all duration-300 ease-out group/mega lg:p-8`}>
                <ul className='flex flex-col  m-0 gap-3  w-full'>

                    {items && items?.map((i_, i) => {
                        return <li key={i} className='flex items-center justify-start text-sm text-left hover:text-[--color-button-3] transition-all duration-150'>
                            <Link to={i_.href} onClick={onClick} >{i_.label}</Link>
                        </li>
                    })}
                </ul>

            </div>
        )
    }
}
export default DefaultMenus;